<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogRoleNotExpire" persistent max-width="960px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span v-if="authenType === 'nearExpire'" class="ra-head-text-bold pa-1" style="color: black;">สิทธิ์ใกล้หมดอายุ</span>
        <span v-else class="ra-head-text-bold pa-1" style="color: black;">สิทธิ์หมดอายุ</span>
        <!-- <v-btn absolute right top class="ma-2 mr-8" color="#3776E9" dark @click="dialogConfirmSubmit = true">บันทึกข้อมูล</v-btn> -->
        <v-btn absolute right top icon x-small @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-row justify="center" align="center">
        <v-col cols="11" class="text-center ">
          <v-divider
          ></v-divider>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row align="center">
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="txt-head" style="color: #3776E9; font-size: 16px;">ข้อมูลการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="12">
                  <span class="ra-head-text">ชื่อสิทธิ์ย่อย: </span><span class="ra-head-text" style="font-weight: 550;">{{subRole}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">สถานะ: </span><span class="ra-head-text" style="font-weight: 550;">{{status}}</span>
                  <!-- <span>สถานะ: {{ statusList.filter(e => e.status === status)[0].statusTH || '-' }}</span> -->
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">รูปแบบการอนุมัติ: </span><span class="ra-head-text" style="font-weight: 550;">{{approveType}}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="txt-head" style="color: #3776E9; font-size: 16px;">ระยะเวลาการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="12">
                  <span class="ra-head-text">วันที่โอนสิทธิ์: </span><span class="ra-head-text" style="font-weight: 550;">{{initDate(this.createAt)}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">ระยะเวลาการรับสิทธิ์: </span><span class="ra-head-text" style="font-weight: 550;">{{initDate(this.startTransferDate)}} - {{initDate(this.endTransferDate)}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">ใกล้หมดอายุ : </span><span class="ra-head-text" style="font-weight: 550;">{{this.nearExpire}}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <div class="mt-4">
          <span class="ra-head-text-bold pa-1">ผู้ที่ถูกโอนสิทธิ์</span>
        </div>
        <v-row class="mt-2">
          <v-spacer/>
          <v-col cols="5" class="pt-0 d-flex flex-row align-center justify-start">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              outlined
              dense
              clearable
              class="mt-0"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="7" class="pt-0 d-flex flex-row align-center justify-end">
            <v-btn v-show="authenType === 'nearExpire'" class="ra-button1 mx-2" color="#1654C6" outlined @click="dialogConfirmCancel = true">ยกเลิกสิทธิ์</v-btn>
            <v-btn class="ra-button1 mx-2" color="#1654C6" dark @click="openDialogRenewal()">
              <v-icon
                color="#3776E9 darken-2"
                class="pl-0 px-1"
                small
              >
                mdi-account-multiple
              </v-icon>
                <span>ต่ออายุสิทธิ์</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="px-0">
            <v-data-table
              :headers="headersPrimaryRole"
              :items="roleNotExpireData"
              :items-per-page="5"
              :search="search"
              class="border-table-employee text-no-wrap mt-1 elevation-0"
              item-key="no"
              :expanded.sync="expanded"
              hide-default-footer
              disable-sort
              :loading="loading"
              loading-text="Loading... Please wait"
            >
            <template v-slot:item="{ item, index }">
              <tr style="cursor: pointer;">
                <td>{{ index + 1 }}</td>
                <td>{{ item.nameTh }}</td>
                <td>{{ item.position }}</td>
                <td>{{ item.positionLevel }}</td>
                <td>{{ item.comapanyName }}</td>
              </tr>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ra-button1 mx-2" color="#1654C6" dark @click="closeDialog">ปิด</v-btn>
          <!-- <v-btn v-show="authenType === 'nearExpire'" class="ra-button1 mx-2" color="#1654C6" outlined @click="dialogConfirmCancel = true">ยกเลิกสิทธิ์</v-btn> -->
          <!-- <v-btn class="ra-button1 mx-2" color="#1654C6" dark @click="openDialogRenewal()">
            <v-icon
              color="#3776E9 darken-2"
              class="pl-0"
              small
            >
              mdi-account-multiple
            </v-icon>
              <span>ต่ออายุสิทธิ์</span>
          </v-btn> -->
        </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmCancel" max-width="500px">
    <v-card height="180px">
      <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกสิทธิ์นี้ใช่ไหม</v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสิทธิ์</span>
      </v-card-text>
      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmCancel = false">ยกเลิก</v-btn>
        <v-btn class="ra-button1" color="#1654C6" dark @click="submitCancelRole()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <dialogRoleRenewal/>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import
{
// hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'
import dialogRoleRenewal from '../../_managetransferrole/_dialog/dialogRoleRenewal'
const moment = require('moment')

export default {
  name: 'dialog-create-approver',
  components: {
    OverlayLoading,
    dialogRoleRenewal
  },
  data () {
    return {
      expanded: [],
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogRoleNotExpire: false,
      dialogConfirmCancel: false,
      selected: [],
      itemUser: [],
      total: -1,
      perPage: 15,
      page: 1,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      // approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader',
      approveRole: 'Admin',
      authenType: '',
      propsId: '',
      search: '',
      searchEmpoyee: '',
      dataSearchEmployee: '',
      typeAction: '',
      subRole: '',
      status: '',
      approveType: '',
      createAt: '',
      startTransferDate: '',
      endTransferDate: '',
      nearExpire: '',
      roleNotExpireData: '',
      employeeData: [
        {
          no: '1',
          primaryRole: 'test',
          position: 'Sale',
          positionLevel: 'Manager',
          company: 'INET',
          transferDate: 'Date',
          expireRole: 'Expire',
          comExpireRole: 'testExpire',
          status: 'approve',
          orgChartHeaderName: 'ขอนแก่น'

        },
        {
          no: '2',
          primaryRole: 'tes2',
          position: 'Sale',
          positionLevel: 'Manager',
          company: 'INET',
          transferDate: 'Date2',
          expireRole: 'Expire2',
          comExpireRole: 'testExpire2',
          status: 'pending',
          orgChartHeaderName: 'กรุงเทพ'
        }
      ],
      headersPrimaryRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ชื่อผู้รับสิทธิ์', value: 'nameTh' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: 'บริษัท', value: 'comapanyName' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('dialogRoleNotExpire')
    EventBus.$off('closeDialogAuthen')
  },
  async mounted () {
    await EventBus.$on('dialogRoleNotExpire', this.openDialogRoleExpire)
    await EventBus.$on('closeDialogAuthen', this.closeDialog)
  },
  watch: {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    // this.getUser()
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogRoleExpire (value, type) {
      this.propsId = value._id
      this.authenType = type
      await this.getRoleExpireDetail(value._id)
      this.loading = true
      this.dialogRoleNotExpire = true
      this.loading = false
    },
    closeDialog () {
      this.dialogRoleNotExpire = false
      EventBus.$emit('closeDialogRoleNotExpire')
    },
    clearSearchEmployee () {
    },
    cancelRole (val) {
      // console.log('cancel role', val)
    },
    editRole (val) {
      // console.log('edit role', val)
    },
    renewalRole (val) {
      // console.log('renewal role', val)
    },
    openDialogRenewal () {
      EventBus.$emit('dialogRoleRenewal', this.propsId)
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY')
      // return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    async getRoleExpireDetail (id) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenTransferById`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          // authenId: '6188d3137467641a4d807e7b',
          authenId: id,
          search: '',
          position: [''],
          positionLevel: [''],
          limit: 15,
          page: 1
        }
      }).then((response) => {
        this.subRole = response.data.result[0].authenName
        this.status = this.statusList.filter(e => e.status === response.data.result[0].status)[0].statusTH
        this.approveType = response.data.result[0].conditions === 'all' ? 'อนุมัติทุกคน' : 'อนุมัติแค่คนใดคนหนึ่ง'
        this.createAt = response.data.result[0].createAt
        this.startTransferDate = response.data.result[0].startDate
        this.endTransferDate = response.data.result[0].endDate
        this.nearExpire = response.data.result[0].statusExpire === true ? 'หมดอายุ' : response.data.result[0].expire
        this.roleNotExpireData = response.data.result[0].transfer
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async submitCancelRole () {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/cancelAuthen`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsId,
          userId: ''
        }
      }).then((response) => {
        if (response.data.success) {
          swal('สำเร็จ', 'ยกเลิกสิทธิ์สำเร็จ', 'success', {
            button: false,
            timer: 1000
          })
          this.getRoleExpireDetail(this.propsId)
          this.loading = false
          this.dialogConfirmCancel = false
          this.dialogRoleRenewal = false
        } else {
          swal('ผิดพลาด', 'ยกเลิกสิทธิ์ไม่สำเร็จ', 'error', {
            button: false,
            timer: 1500
          })
        }
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */
  display: flex;
  align-items: center;

  /* Color / Primary / Hover */
  color: #1654C6;
  /* color: black; */
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
